/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Portal_Step_Find_TitleInputs */

const en_portal_step_find_title = /** @type {(inputs: Portal_Step_Find_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pick a coach`)
};

const pl_portal_step_find_title = /** @type {(inputs: Portal_Step_Find_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wybierz trenera`)
};

/**
* | output |
* | --- |
* | "Pick a coach" |
*
* @param {Portal_Step_Find_TitleInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const portal_step_find_title = /** @type {((inputs?: Portal_Step_Find_TitleInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Portal_Step_Find_TitleInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_portal_step_find_title(inputs)
	return en_portal_step_find_title(inputs)
});